import dynamic from 'next/dynamic';
import { FEATURES_LIST, FeatureSwitchContext, IFeatureSwitchContext } from '../../context/featureSwitchApp';
import React, { useContext } from 'react';
import { NextPage } from 'next';
import { getFeatureSwitch } from '@utils/featureSwitches.utils';
import { FinanceWidgetProps } from '@components/FinanceWidget/shared';
import { detectBrowserVersion } from '@utils/misc.utils';

const FinanceWidgetV1Component = dynamic(() => import('./FinanceWidgetV1'), { ssr: false });
const FinanceWidgetV2Component = detectBrowserVersion().supported
    ? dynamic(() => import('./FinanceWidgetV2'), { ssr: false })
    : null;

const financeWidgetVersionComponents: Record<
    IFeatureSwitchContext['FEATURE_SWITCH_FINANCE_WIDGET_VERSION'],
    React.ComponentType<FinanceWidgetProps>
> = {
    v1: FinanceWidgetV1Component,
    v2: FinanceWidgetV2Component,
};

const FinanceWidgetPreparation: NextPage<FinanceWidgetProps> = (props) => {
    const context = useContext(FeatureSwitchContext);

    const financeWidgetVersion = getFeatureSwitch(FEATURES_LIST.FEATURE_SWITCH_FINANCE_WIDGET_VERSION, context);

    const Component = financeWidgetVersionComponents[(financeWidgetVersion as 'v1' | 'v2') ?? 'v1'];
    return Component ? <Component {...props} /> : null;
};

export default FinanceWidgetPreparation;
